import styled from 'styled-components';
import { boxShadow, maxWidth, retina } from 'Utils/utilsStyle';

const Wrapper = styled.div`
  overflow: hidden;
  border-radius: 8px;
  max-width: 100%;
  min-height: 146px;
  margin-bottom: 20px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: ${boxShadow};
  @media all and (max-width: ${maxWidth}) , ${retina} {
    min-width: 218px;
  }
  .skeleton-box{
    height: 33px;
    width:113px;
    border-radius: 25px;
    margin:0 auto;
    display:block;
  }
  .company-name{
    height:20px;
    width:80px;
    margin-top:15px;
  }
`;

const FinancialStatsSkeleton = function FinancialStatsSkeleton() {
  return (
    <Wrapper>
      <span className="skeleton-box" />
      <span className="skeleton-box company-name" />
    </Wrapper>
  );
};

export default FinancialStatsSkeleton;
